<template>
    <v-sheet>
        <v-tabs v-model="levelTwoTab" color="primary" density="compact">
            <v-tab value="Materials" @click="handleMateiralsOrOperationsClick">Materials</v-tab>
            <v-tab value="Operations" @click="handleMateiralsOrOperationsClick">Operations</v-tab>
            <v-tab value="Assemblies" @click="handleAssembliesChange">Assemblies</v-tab>
        </v-tabs>

        <v-divider></v-divider>

        <v-window v-model="levelTwoTab">
            <v-window-item value="Materials" class="py-3">
                <MaterialsWindow />
            </v-window-item>

            <v-window-item value="Operations" class="py-3">
                <OperationsWindow />
            </v-window-item>

            <v-window-item value="Assemblies" class="py-3">
                <AssembliesWindow ref="AssembliesWindowRef" />
            </v-window-item>
        </v-window>
    </v-sheet>
</template>

<script>
    import MaterialsWindow from "./JobDetailsWindow/MaterialsWindow.vue";
    import OperationsWindow from "./JobDetailsWindow/OperationsWindow.vue";
    import AssembliesWindow from "./JobDetailsWindow/AssembliesWindow.vue";
    import { useJobEntryStore } from '../../../../stores/ProjectManagement/JobEntry';
    import { mapWritableState } from 'pinia';

    export default {
        name: "JobDetailsWindow",
        components: {
            MaterialsWindow,
            OperationsWindow,
            AssembliesWindow
        },
        computed: {
            ...mapWritableState(useJobEntryStore, {
                levelTwoTab: "levelTwoTab",
                levelThreeTab: "levelThreeTab",
                setCurrentAssemblyMaterials: "setCurrentAssemblyMaterials",
                fetchJobData: "fetchJobData",
                job: 'job'
            }),
        },
        watch: {},
        methods: {
            handleMateiralsOrOperationsClick() {
                this.levelThreeTab = 'Detail'
            },
            handleAssembliesChange() {
                this.levelThreeTab = 'Assembly';
            }
        }
    }
</script>

<style scoped>

</style>
